export default __webpack_public_path__ + "media/components/Courses/Show/Images/disciplines/6-0f60c303cf8678e31316a2e38d8955d1.svg";